import React, { Component } from 'react';
import ModalOverlay from "../../../../../components/UI/ModalOverlay";
import theme from '../../../../../Theme/theme';
import Button from '../../../../../components/UI/Button';
import axios from "axios";
import { toast } from "react-toastify";
import { API_URL } from "config/constants";
import { decimalFilter } from '../../../../../common/Utils'

const EDIT_GYM_TITLE = "EDIT DETAILS";
const DONE_TEXT = "SAVE";
const CLOSE_TEXT = "CLOSE"
const GYM_NAME = "Gym Name";
const EMAIL = "Email"
const RATE = "Rate $/min"

export default class EditModal extends Component {

    constructor (props) {
        super(props);
        console.log(this.props.gym);        
        this.state = {
            gym_name: props.gym.gym_name,
            email: props.gym.email,
            rate : props.gym.rate
        }
    }

    render () {
        return (
            <ModalOverlay
                modalStyle={style.modalStyle}
                header={EDIT_GYM_TITLE}
                headerStyle={style.headerStyle}
                headerBodyStyle={style.headerBodyStyle}
                bodyStyle={style.modalBody}
                underLayerStyle={style.underLayer}
                close={this.props.close}>
                <div style={style.selectorWrapper}>
                    <p style={style.selectorLabel}>{GYM_NAME} &nbsp; &nbsp;</p>
                    <input
                        value={this.state.gym_name}
                        style={{ ...style.input, ...{ backgroundColor: theme.color.textLightWhite } }}
                        onChange={e => {
                            this.setState({
                                gym_name: e.target.value
                            });
                        }}
                    />
                </div>
                <div style={style.selectorWrapper}>
                    <p style={style.selectorLabel}>{EMAIL} &nbsp; &nbsp;</p>
                    <input
                        value={this.state.email}
                        style={{ ...style.input, ...{ backgroundColor: theme.color.textLightWhite } }}
                        onChange={e => {
                            this.setState({
                                email: e.target.value
                            });
                        }}
                    />
                </div>
                <div style={style.selectorWrapper}>
                    <p style={style.selectorLabel}>{RATE} &nbsp; &nbsp;</p>
                    <input
                        value={this.state.rate}
                        style={{ ...style.input, ...{ backgroundColor: theme.color.textLightWhite } }}
                        onChange={e => {
                            if (!isNaN(e.target.value) && decimalFilter(e.target.value, 2)) {
                                this.setState({
                                    rate: e.target.value
                                });
                            }
                        }}
                    />
                </div>
                <div style={style.doneButtonWrapper}>
                    <Button
                        style={style.doneButton}
                        type="primary"
                        onClick={this.save}>
                        {DONE_TEXT}
                    </Button>
                    <Button
                        style={style.closeButton}
                        type="primary"
                        onClick={this.props.close}>
                        {CLOSE_TEXT}
                    </Button>
                </div>
            </ModalOverlay>
        )
    }

    save = () => {
        if(!this.state.gym_name) {
            toast("Please provide gym name")
        } else if (!this.state.email) {
            toast("Please provide email address")
        } else if (!this.state.rate) {
            toast("Please provide rate")
        } else {
            var toastId = toast("Updating details...")
            axios.put(
            `${API_URL}/admin/gyms/${this.props.gym.gym_id}`,
            this.state,
            {
                headers: {
                    "x-access-token": localStorage.getItem("access_token")
                }
            }).then(()=>{
                var gym = this.props.gym
                gym.gym_name = this.state.gym_name
                gym.email = this.state.email
                gym.rate = parseFloat(this.state.rate)
                toast.dismiss(toastId);
                toastId = toast("Updated successfully");
                setTimeout(() => {
                    this.props.close();
                    toast.dismiss(toastId);
                }, 1000)
            }).catch((e)=>{
                toast.dismiss(toastId);
                toastId = toast("Updated failed " + e.message);
                setTimeout(() => {
                    toast.dismiss(toastId);
                }, 2000)
            })
        }
    }
}

const style = {
    modalStyle: {
        backgroundColor: theme.color.white,
        borderRadius: 3
    },
    underLayer: {
        backgroundColor: theme.color.shadowColor
    },
    headerStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        backgroundColor: theme.color.transparent
    },
    headerBodyStyle: {
        width: "100%",
        height: 40,
        fontSize: 25,
        letterSpacing: 0,
        borderRadius: 3,
        lineHeight: "40px",
        fontFamily: theme.font.avenirBlackOblique,
        color: theme.color.thickGrey,
    },
    modalBody: {
        margin: 25,
        marginTop: 0,
        borderRadius: "0px 0px 15px 15px",
        backgroundColor: theme.color.transparent
    },
    doneButtonWrapper: {
        width: "400",
        display: "flex",
        justifyContent: "space-around",
        marginTop: 20
    },
    doneButton: {
        width: "160px",
        fontSize: "20px"
    },
    closeButton: {
        width: "160px",
        fontSize: "20px",
        marginLeft:"20px"
    },
    selectorWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "nowrap",
        height: 70
    },
    selectorLabel: {
        fontSize: "22px",
        color: "#444445",
        marginRight: "15px",
        width: "150px",
        textAlign: "left",
        height: 20
    },
    input: {
        border: "1px solid #444445",
        borderRadius: 50,
        fontSize: 18,
        color: theme.color.primaryBlue,
        padding: 10,
        paddingLeft: 20,
        minWidth: 200,
        textAlign: "left",
        backgroundColor: theme.color.textLightWhite
    },
}